/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadPreviewTranslationsFaceCloseup } from './DocumentUploadPreviewTranslationsFaceCloseup';
import type { DocumentUploadPreviewTranslationsPoint3 } from './DocumentUploadPreviewTranslationsPoint3';
import type { DocumentUploadPreviewTranslationsPoint2 } from './DocumentUploadPreviewTranslationsPoint2';
import type { DocumentUploadPreviewTranslationsTextDocument } from './DocumentUploadPreviewTranslationsTextDocument';
import type { DocumentUploadPreviewTranslationsPoint4 } from './DocumentUploadPreviewTranslationsPoint4';
import type { DocumentUploadPreviewTranslationsOtherPhotograph } from './DocumentUploadPreviewTranslationsOtherPhotograph';
import type { DocumentUploadPreviewTranslationsPoint1 } from './DocumentUploadPreviewTranslationsPoint1';

export interface DocumentUploadPreviewTranslations {
    choose_photo_button_label: string;
    next_button_label: string;
    confirm_button_label: string;
    change_photo_button_label: string;
    readability_title: string;
    readability_description: string;
    point_1: DocumentUploadPreviewTranslationsPoint1;
    point_2: DocumentUploadPreviewTranslationsPoint2;
    point_3: DocumentUploadPreviewTranslationsPoint3;
    point_4: DocumentUploadPreviewTranslationsPoint4;
    confirm_title: string;
    text_document: DocumentUploadPreviewTranslationsTextDocument;
    face_closeup: DocumentUploadPreviewTranslationsFaceCloseup;
    other_photograph: DocumentUploadPreviewTranslationsOtherPhotograph;
}
